import React, { useEffect, useState } from 'react';
import { FaFacebookF, FaYoutube, FaInstagram, FaLinkedinIn, FaPhoneAlt, FaMapMarkerAlt, FaEnvelope } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import AOS from 'aos';
import 'aos/dist/aos.css';
import AppConfig from '../config/appConfig'; // path আপনার ফোল্ডার স্ট্রাকচার অনুযায়ী ঠিক করুন

function Footer() {
  const [footerData, setFooterData] = useState({
    companyName: AppConfig.CompanyName || 'E-Business',
    phones: [AppConfig.phoneNumber || '+8801345688562'],
    emails: ['howtechbd@gmail.com', 'howtechbd@gmail.com'],
    facebookLink: 'https://www.facebook.com/elevateemart',
    instagramLink: 'https://www.instagram.com/elevateemart',
    youtubeLink: 'https://www.youtube.com/@elevateemart',
    xLink: 'https://www.linkedin.com/company/yourcompany',
    officeAddress: 'Madhubag, Mogbazar, Dhaka, Bangladesh',
    aboutDescription: `${AppConfig.CompanyName} is your trusted online shopping platform. We are committed to providing high-quality products and the best customer service.`,
    ctaHeading: 'Ready to Experience Excellence?',
    ctaDescription: `Join thousands of satisfied customers and discover why ${AppConfig.CompanyName} is the preferred choice for your needs.`,
    ctaButtonText: 'Get Started Today',
    ctaButtonLink: '/product',
    quickLinks: [
      { text: 'About Us', url: '/about' },
      { text: 'Refund Policy', url: '/refund-policy' },
      { text: 'My Orders', url: '/order-history' },
      { text: 'Privacy Policy', url: '/privacy-policy' }
    ],
    customerServiceLinks: [
      { text: 'Secure Payment', url: '#' },
      { text: 'Fast Delivery', url: '#' },
      { text: '100% Protection Guarantee', url: '#' },
      { text: 'Easy Return Process', url: '#' }
    ],
    bottomLinks: [
      { text: 'Terms of Service', url: '#' },
      { text: 'Privacy Policy', url: '#' },
      { text: 'Help Center', url: '#' }
    ]
  });

  useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 600,
      once: true,
    });
    AOS.refresh();
  }, []);

  // Fetch footer data from API
  useEffect(() => {
    const fetchFooterData = async () => {
      try {
        const response = await fetch(`${AppConfig.API_BASE_URL}/api/footer`);
        const result = await response.json();

        if (result.success && result.footer) {
          setFooterData({
            companyName: result.footer.companyName || 'E-Business',
            phones: (result.footer.phones && result.footer.phones.length > 0)
              ? result.footer.phones
              : ['+8809647001250', '+8801345688562'],
            emails: (result.footer.emails && result.footer.emails.length > 0)
              ? result.footer.emails
              : ['elevatemart.contact@gmail.com', 'e-business.help@gmail.com'],
            facebookLink: result.footer.facebookLink || 'https://www.facebook.com/elevateemart',
            instagramLink: result.footer.instagramLink || 'https://www.instagram.com/elevateemart',
            youtubeLink: result.footer.youtubeLink || 'https://www.youtube.com/@elevateemart',
            xLink: result.footer.xLink || 'https://www.linkedin.com/company/yourcompany',
            officeAddress: result.footer.officeAddress || 'Madhubag, Mogbazar, Dhaka, Bangladesh',
            aboutDescription: result.footer.aboutDescription || `${AppConfig.CompanyName} is your trusted online shopping platform. We are committed to providing high-quality products and the best customer service.`,
            ctaHeading: result.footer.ctaHeading || 'Ready to Experience Excellence?',
            ctaDescription: result.footer.ctaDescription || `Join thousands of satisfied customers and discover why ${AppConfig.CompanyName} is the preferred choice for your needs.`,
            ctaButtonText: result.footer.ctaButtonText || 'Get Started Today',
            ctaButtonLink: result.footer.ctaButtonLink || '/product',
            quickLinks: (result.footer.quickLinks && result.footer.quickLinks.length > 0)
              ? result.footer.quickLinks
              : [
                { text: 'About Us', url: '/about' },
                { text: 'Refund Policy', url: '/refund-policy' },
                { text: 'My Orders', url: '/order-history' },
                { text: 'Privacy Policy', url: '/privacy-policy' }
              ],
            customerServiceLinks: (result.footer.customerServiceLinks && result.footer.customerServiceLinks.length > 0)
              ? result.footer.customerServiceLinks
              : [
                { text: 'Secure Payment', url: '#' },
                { text: 'Fast Delivery', url: '#' },
                { text: '100% Protection Guarantee', url: '#' },
                { text: 'Easy Return Process', url: '#' }
              ],
            bottomLinks: (result.footer.bottomLinks && result.footer.bottomLinks.length > 0)
              ? result.footer.bottomLinks
              : [
                { text: 'Terms of Service', url: '#' },
                { text: 'Privacy Policy', url: '#' },
                { text: 'Help Center', url: '#' }
              ]
          });
        }
      } catch (error) {
        console.error('Error fetching footer data:', error);
        // Default values already set in state
      }
    };

    fetchFooterData();
  }, []);

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white text-gray-800 mt-20 mb-0 md:mb-0" style={{ fontFamily: "'Assistant', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif" }}>

      {/* Call to Action Section */}
      <section className="py-12 bg-[#131a22] text-white">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">{footerData.ctaHeading}</h2>
          <p className="text-lg md:text-xl mb-6 text-gray-300">
            {footerData.ctaDescription}
          </p>
          <a
            className="inline-block bg-white text-[#131a22] font-bold text-lg px-8 py-3 rounded-full hover:bg-gray-200 transition-all duration-300"
            href={footerData.ctaButtonLink}
          >
            {footerData.ctaButtonText}
          </a>
        </div>
      </section>

      {/* Main Footer Content */}
      <div className="bg-white py-12 px-6">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">

          {/* About Us Section */}
          <div data-aos="fade-up" data-aos-delay="0">
            <h3 className="text-gray-900 text-base font-bold mb-4">Get to Know Us</h3>
            <p className="text-sm leading-relaxed mb-4 text-gray-700">
              {footerData.aboutDescription}
            </p>
            <div className="flex gap-3 mt-4">

              <a href={footerData.facebookLink}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-200 hover:bg-[#febd69] rounded-full flex items-center justify-center transition-all duration-300 text-gray-800"
              >
                <FaFacebookF className="text-base" />
              </a>

              <a href={footerData.youtubeLink}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-200 hover:bg-[#febd69] rounded-full flex items-center justify-center transition-all duration-300 text-gray-800"
              >
                <FaYoutube className="text-base" />
              </a>

              <a href={footerData.instagramLink}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-200 hover:bg-[#febd69] rounded-full flex items-center justify-center transition-all duration-300 text-gray-800"
              >
                <FaInstagram className="text-base" />
              </a>

              <a href={footerData.xLink}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-200 hover:bg-[#febd69] rounded-full flex items-center justify-center transition-all duration-300 text-gray-800"
              >
                <FaXTwitter className="text-base" />
              </a>
            </div>
          </div>

          {/* Quick Links Section */}
          <div data-aos="fade-up" data-aos-delay="100">
            <h3 className="text-gray-900 text-base font-bold mb-4">Make Money with Us</h3>
            <ul className="space-y-2">
              {footerData.quickLinks.map((link, index) => (
                <li key={index}>
                  <a href={link.url} className="text-sm text-gray-700 hover:text-[#febd69] hover:underline transition-colors duration-200">
                    {link.text}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Customer Service Section */}
          <div data-aos="fade-up" data-aos-delay="200">
            <h3 className="text-gray-900 text-base font-bold mb-4">Let Us Help You</h3>
            <ul className="space-y-2">
              {footerData.customerServiceLinks.map((link, index) => (
                <li key={index}>
                  <a href={link.url} className="text-sm text-gray-700 hover:text-[#febd69] hover:underline transition-colors duration-200">
                    {link.text}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Section */}
          <div data-aos="fade-up" data-aos-delay="300">
            <h3 className="text-gray-900 text-base font-bold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm">
                <FaPhoneAlt className="text-[#febd69] mt-1 flex-shrink-0" />
                <div className="flex flex-col gap-1">
                  {footerData.phones.map((phone, index) => (

                    <a key={index}
                      href={`tel:${phone}`}
                      className="text-gray-700 hover:text-[#febd69] transition-colors"
                    >
                      {phone}
                    </a>
                  ))}
                </div>
              </li>
              <li className="flex items-start gap-2 text-sm">
                <FaEnvelope className="text-[#febd69] mt-1 flex-shrink-0" />
                <div className="flex flex-col gap-1">
                  {footerData.emails.map((email, index) => (

                    <a key={index}
                      href={`mailto:${email}`}
                      className="text-gray-700 hover:text-[#febd69] transition-colors break-all"
                    >
                      {email}
                    </a>
                  ))}
                </div>
              </li>
              <li className="flex items-start gap-2 text-sm">
                <FaMapMarkerAlt className="text-[#febd69] mt-1 flex-shrink-0" />
                <span className="text-gray-700">{footerData.officeAddress}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* SSL Commerce Payment Logo */}
      <div className="bg-white py-8 md:py-12 border-t border-gray-200">
        <div className="w-full px-4 md:px-6 flex justify-center">
          <img
            src="https://securepay.sslcommerz.com/public/image/SSLCommerz-Pay-With-logo-All-Size-01.png"
            alt="SSL Commerce Payment Gateway"
            className="w-full max-w-5xl h-auto object-contain"
          />
        </div>
      </div>

      {/* Bottom Bar - Mobile এ extra padding যোগ করা হয়েছে */}
      <div className="bg-[#131a22] py-6 px-6 border-t border-[#3a4553] pb-6 md:pb-6 max-md:pb-24">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm">
            <p className="text-gray-400">
              © {currentYear} {footerData.companyName}. All rights reserved.
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              {footerData.bottomLinks.map((link, index) => (
                <React.Fragment key={index}>
                  <a href={link.url} className="text-gray-400 hover:text-white transition-colors">
                    {link.text}
                  </a>
                  {index < footerData.bottomLinks.length - 1 && (
                    <span className="text-gray-600">|</span>
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>

    </footer>
  );
}

export default Footer;